// The loader's worker is a plain file in public/ (generated by scripts/make-loader-worker.py). It is cached for a year, so a change to it is a NEW name: bump VERSION there, here and in
// public/index.html (which starts the same worker before this app has loaded).
export const LOADER_WORKER_URL = `${process.env.PUBLIC_URL || ""}/loader-worker.v1.js`;
